import React from 'react';
import { TextField } from '@fluentui/react/lib/TextField';
import isFinite from 'lodash/isFinite';
import isUndefined from 'lodash/isUndefined';
import isNil from 'lodash/isNil';
import isString from 'lodash/isString';

export const NumberInput = ({
    onChange,
    value,
    ...props
}) => (
    <TextField
        {...props}
        onChange={(event, value) => {
            (isUndefined(value) || value === '' || isFinite(+value)) && onChange(event, value);
        }}
        value={isString(value) || isNil(value) ? value : value.toString()}
    />
);
